import { string, object } from 'yup';

export const presetSchema = object({
  name: string().required('nameRequiredMessage'),
  // Not stoked about this test but it replicates the existing functionality as good as I can with yup and gives us a ground to expand upon the validation of presets!
  presetOptions: object().test(
    'oneOrMoreRequired',
    'oneOrMoreRequired',
    (presetOptions) => !!Object.values(presetOptions).filter((v) => !!v).length,
  ),
});
